// extracted by mini-css-extract-plugin
export default {"root":"toolbar_root__VxS8L","actions":"toolbar_actions__3Fcn4","noTopPadding":"toolbar_noTopPadding__oPgev","shortcutSection":"toolbar_shortcutSection__bwTKk"};